function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 1149,
  height: 1132,
  fill: "#303030"
});
var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_703_220)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M574.489 430C542.119 429.999 510.066 436.374 480.16 448.761C450.253 461.148 423.08 479.304 400.192 502.194C377.303 525.083 359.147 552.258 346.76 582.165C334.373 612.072 327.999 644.125 328 676.496H388.82C394.309 676.54 399.624 674.577 403.766 670.974C407.908 667.372 410.589 662.379 411.306 656.937C415.028 625.718 427.657 596.231 447.684 571.997C451.03 567.936 454.565 564.046 458.29 560.328C480.08 538.516 507.567 523.275 537.609 516.348C567.651 509.422 599.037 511.088 628.177 521.158C657.317 531.227 683.035 549.293 702.392 573.291C721.749 597.288 733.962 626.248 737.636 656.859C738.34 662.312 741.015 667.318 745.155 670.936C749.295 674.553 754.615 676.53 760.113 676.496H821C820.994 611.123 795.022 548.43 748.797 502.204C702.573 455.978 639.882 430.006 574.511 430",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M570.764 574.433C583.379 574.433 595.71 578.173 606.199 585.182C616.688 592.191 624.863 602.152 629.691 613.807C634.518 625.462 635.781 638.287 633.319 650.66C630.858 663.033 624.784 674.398 615.864 683.318C606.944 692.238 595.58 698.313 583.207 700.774C570.835 703.236 558.01 701.972 546.356 697.145C534.701 692.317 524.739 684.142 517.731 673.653C510.722 663.163 506.981 650.831 506.981 638.216C506.984 621.3 513.706 605.079 525.666 593.118C537.627 581.156 553.849 574.436 570.764 574.433",
  fill: "white"
}));
var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_703_220"
}, /*#__PURE__*/React.createElement("rect", {
  width: 493,
  height: 272,
  fill: "white",
  transform: "translate(328 430)"
})));
function SvgFallbackProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1149,
    height: 1132,
    viewBox: "0 0 1149 1132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFallbackProduct);
export default __webpack_public_path__ + "static/media/fallbackProduct.fdc7e0d6dd582082714758db50eeccd2.svg";
export { ForwardRef as ReactComponent };